'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

var _utils = require('../utils');

var _images = require('../utils/images');

var _videos = require('../utils/videos');

var _utils2 = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var MODULE_NAME = 'js-Carousel';

var classes = {
  CAROUSEL_ENABLED: 'car-Products-carouselEnabled',
  CAROUSEL_DISABLED: 'car-Products-carouselDisabled',
  LAZYLOAD_GALLERY: 'lazyload-gallery',
  HIDE: 'util-Hide'
};

var selectors = {
  RESPONSIVE_IMAGE: '.rsp-Image_Image',
  RESPONSIVE_VIDEO: '.rsp-Video_Video'
};

var Carousel = function () {
  function Carousel(el) {
    (0, _classCallCheck3.default)(this, Carousel);

    this.el = el;
    this.els = this.getEls();
    this.config = this.getConfig();
    this.swiperConfig = this.getSwiperConfig();
    this.swiperModules = this.getSwiperModules();
    this.init();
  }

  (0, _createClass3.default)(Carousel, [{
    key: 'init',
    value: function init() {
      if (this.isMobileOnlyCarousel()) {
        if ((0, _utils.mediaBreakpointMatches)('xs')) {
          this.carousel = (0, _utils2.initialiseSwiper)(this.els.carousel, this.swiperConfig, this.swiperModules);
          this.loadImages();
        } else {
          this.els.carousel.classList.remove(classes.CAROUSEL_ENABLED);
          this.els.carousel.classList.add(classes.CAROUSEL_DISABLED);
          this.hidePagination();
          this.loadAllImages();
          this.harmonizeAnything();
        }
      } else if (this.isDesktopOnlyCarousel()) {
        if (!(0, _utils.mediaBreakpointMatches)('xs')) {
          this.carousel = (0, _utils2.initialiseSwiper)(this.els.carousel, this.swiperConfig, this.swiperModules);
          this.loadImages();
        } else {
          this.els.carousel.classList.remove(classes.CAROUSEL_ENABLED);
          this.els.carousel.classList.add(classes.CAROUSEL_DISABLED);
          this.hidePagination();
          this.loadAllImages();
          this.harmonizeAnything();
        }
      } else {
        this.carousel = (0, _utils2.initialiseSwiper)(this.els.carousel, this.swiperConfig, this.swiperModules);

        if (this.hasMobileOnlySlide() && (0, _utils.mediaBreakpointMatches)('xs')) {
          var index = 0;
          if (this.els.mobileOnlySlide.hasAttribute('data-mobile-slide-index')) {
            index = parseInt(this.els.mobileOnlySlide.getAttribute('data-mobile-slide-index'));
          }
          this.carousel.addSlide(index, this.els.mobileOnlySlide.outerHTML);
          /* Once slide gets added, we need to scroll back to it, otherwise the initial first (now second) slide is shown */
          if (!this.els.mobileOnlySlide.hasAttribute('data-mobile-slide-skip-move-to')) {
            this.carousel.slidePrev();
          }
        }
      }
    }
  }, {
    key: 'loadImages',
    value: function loadImages() {
      var _this2 = this;

      this.carousel.on('slideChange', function () {
        var currentSlide = _this2.carousel.slides[_this2.carousel.activeIndex];
        var slideImage = (0, _functional.getElement)(selectors.RESPONSIVE_IMAGE, { context: currentSlide });
        var slideVideo = (0, _functional.getElement)(selectors.RESPONSIVE_VIDEO, { context: currentSlide });

        if (slideImage) {
          (0, _images.loadImage)(slideImage, { loadingClass: classes.LAZYLOAD_GALLERY });
        } else if (slideVideo) {
          (0, _videos.loadVideo)(slideVideo, { loadingClass: classes.LAZYLOAD_GALLERY });
        }
      });
    }
  }, {
    key: 'loadAllImages',
    value: function loadAllImages() {
      (0, _images.loadImages)(selectors.RESPONSIVE_IMAGE, this.els.carousel, classes.LAZYLOAD_GALLERY);
      (0, _videos.loadVideos)(selectors.RESPONSIVE_VIDEO, this.els.carousel, classes.LAZYLOAD_GALLERY);
    }
  }, {
    key: 'isMobileOnlyCarousel',
    value: function isMobileOnlyCarousel() {
      if (this.config.mobileOnly != null) {
        return true;
      }
      return false;
    }
  }, {
    key: 'isDesktopOnlyCarousel',
    value: function isDesktopOnlyCarousel() {
      if (this.config.desktopOnly != null) {
        return true;
      }
      return false;
    }
  }, {
    key: 'hasMobileOnlySlide',
    value: function hasMobileOnlySlide() {
      if (this.els.mobileOnlySlide != null) {
        return true;
      }
      return false;
    }
  }, {
    key: 'useAutoplay',
    value: function useAutoplay() {
      if (this.config.autoplay != null) {
        return true;
      }
      return false;
    }
  }, {
    key: 'useNavigation',
    value: function useNavigation() {
      if (this.els.navigation != null) {
        return true;
      }
      return false;
    }
  }, {
    key: 'usePagination',
    value: function usePagination() {
      if (this.els.pagination != null) {
        return true;
      }
      return false;
    }
  }, {
    key: 'hidePagination',
    value: function hidePagination() {
      if (this.usePagination()) {
        this.els.pagination.classList.add(classes.HIDE);

        if (this.els.paginationWrapper) {
          this.els.paginationWrapper.classList.add(classes.HIDE);
        }
      }
    }
  }, {
    key: 'harmonizeAnything',
    value: function harmonizeAnything() {
      if (this.el.querySelectorAll('[data-harmonize]').length) {
        (0, _functional.harmonizeElements)({ context: this.el });
      }
    }
  }, {
    key: 'getSwiperConfig',
    value: function getSwiperConfig() {
      var autoplay = false;
      var breakpoints = {};
      var navigation = {};
      var pagination = {};
      var slidesToShow = 1.4;
      var _this = this;

      if (this.useAutoplay()) {
        if (this.config.autoplay.length !== 0) {
          autoplay = {
            delay: parseInt(this.config.autoplay)
          };
        } else {
          autoplay = true;
        }
      }

      if (!this.isMobileOnlyCarousel() && this.config.disableBreakpoints == null) {
        var _breakpoints;

        breakpoints = {
          breakpoints: (_breakpoints = {}, (0, _defineProperty3.default)(_breakpoints, _utils.mediaBreakpoints.sm, {
            slidesPerView: 2,
            centeredSlides: false
          }), (0, _defineProperty3.default)(_breakpoints, _utils.mediaBreakpoints.lg, {
            slidesPerView: 4,
            spaceBetween: 28,
            centeredSlides: false
          }), _breakpoints)
        };
      }

      if (this.usePagination()) {
        var useDynamicBullets = !this.els.pagination.hasAttribute('data-disable-dynamic');
        if (this.els.slides.length > 5) {
          pagination = {
            pagination: {
              el: this.els.pagination,
              dynamicBullets: useDynamicBullets,
              dynamicMainBullets: 3
            }
          };
        } else {
          pagination = {
            pagination: {
              el: this.els.pagination
            }
          };
        }
      }

      if (this.useNavigation()) {
        navigation = {
          navigation: {
            nextEl: '.' + MODULE_NAME + '_Next',
            prevEl: '.' + MODULE_NAME + '_Prev'
          }
        };
      }

      if (this.config.slidesToShow != null) {
        slidesToShow = parseFloat(this.config.slidesToShow);
      }

      var spaceBetween = this.config.noSpaceBetween ? 0 : 16;

      var defaultConfig = (0, _assign2.default)({
        autoplay: autoplay
      }, breakpoints, {
        centeredSlides: true,
        loop: true
      }, navigation, pagination, {
        slideClass: MODULE_NAME + '_Slide',
        slidesPerView: slidesToShow,
        spaceBetween: spaceBetween,
        speed: 500,
        watchSlidesProgress: true,
        wrapperClass: MODULE_NAME + '_Wrapper',
        on: {
          init: function init() {
            _this.harmonizeAnything();
          }
        }
      });

      return defaultConfig;
    }
  }, {
    key: 'getSwiperModules',
    value: function getSwiperModules() {
      var swiperModules = [];

      if (this.hasMobileOnlySlide()) {
        swiperModules.push('Manipulation');
      }

      if (this.useAutoplay()) {
        swiperModules.push('Autoplay');
      }

      if (this.useNavigation()) {
        swiperModules.push('Navigation');
      }

      if (this.usePagination()) {
        swiperModules.push('Pagination');
      }

      return swiperModules;
    }
  }, {
    key: 'getConfig',
    value: function getConfig() {
      var _el$dataset = this.el.dataset,
          autoplay = _el$dataset.autoplay,
          mobileOnly = _el$dataset.mobileOnly,
          desktopOnly = _el$dataset.desktopOnly,
          slidesToShow = _el$dataset.slidesToShow,
          disableBreakpoints = _el$dataset.disableBreakpoints,
          noSpaceBetween = _el$dataset.noSpaceBetween;

      return {
        autoplay: autoplay,
        mobileOnly: mobileOnly,
        desktopOnly: desktopOnly,
        slidesToShow: slidesToShow,
        disableBreakpoints: disableBreakpoints,
        noSpaceBetween: noSpaceBetween !== undefined
      };
    }
  }, {
    key: 'getEls',
    value: function getEls() {
      var context = this.el;

      return {
        carousel: (0, _functional.getElement)('.' + MODULE_NAME + '_Element', { context: context }),
        carouselWrapper: (0, _functional.getElement)('.' + MODULE_NAME + '_Wrapper', { context: context }),
        slides: (0, _functional.getElements)('.' + MODULE_NAME + '_Slide', { context: context }),
        pagination: (0, _functional.getElement)('.' + MODULE_NAME + '_Pagination', { context: context }),
        paginationWrapper: (0, _functional.getElement)('.' + MODULE_NAME + '_PaginationWrapper', { context: context }),
        navigation: (0, _functional.getElement)('.' + MODULE_NAME + '_Navigation', { context: context }),
        mobileOnlySlide: (0, _functional.getElement)('.' + MODULE_NAME + '_MobileSlide', { context: context })
      };
    }
  }]);
  return Carousel;
}();

var init = exports.init = function init(_ref) {
  var el = _ref.el;
  return new Carousel(el);
};